import React from 'react';

import { Paper, Table, TableHead, TableContainer, TableBody } from '@mui/material';

import { StyledTableCell, StyledTableRow, useStyles, StyledTableHeaderCell } from '../styles';

export const TokenVesting = ({ alloc_details }) => {
  const styles = useStyles();

  return (
    <>
      <TableContainer sx={{ maxHeight: 900 }} component={Paper} variant="outlined" elevation="8">
        <Table aria-label="sticky table">
          <TableHead classsName={styles.tableHeader}>
            <StyledTableHeaderCell align="center" size="medium" className={styles.sticky}>
              Type
            </StyledTableHeaderCell>
            <StyledTableHeaderCell align="center" size="small">
              Percentage
            </StyledTableHeaderCell>
            <StyledTableHeaderCell align="center" size="small">
              Token Allocation
            </StyledTableHeaderCell>
            <StyledTableHeaderCell align="center" size="small">
              TGE
            </StyledTableHeaderCell>
            <StyledTableHeaderCell align="center" size="medium" style={{ minWidth: '100px' }}>
              TGE %
            </StyledTableHeaderCell>

            <StyledTableHeaderCell size="medium" align="center" style={{ minWidth: '200px' }}>
              Vesting Details
            </StyledTableHeaderCell>
          </TableHead>
          <TableBody>
            {alloc_details.map((row) => {
              return (
                <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  <StyledTableCell
                    className={styles.sticky}
                    key={'token_name'}
                    style={{ minWidth: '100px' }}
                    align="center">{`${row['type']}`}</StyledTableCell>

                  <StyledTableCell key={'supply_per'} align="center">
                    {row['allocation']}
                  </StyledTableCell>
                  <StyledTableCell key={'alloc_supply'} align="center">
                    {row['alloc_supply']?.toLocaleString(undefined, {
                      minimumFractionDigits: 2
                    })}
                  </StyledTableCell>
                  <StyledTableCell key={row['tge_supply']} align="center">
                    {row['tge_supply']?.toLocaleString(undefined, { minimumFractionDigits: 0 })}
                  </StyledTableCell>
                  <StyledTableCell key={row['tge']} align="center">
                    {row['tge']}
                  </StyledTableCell>
                  <StyledTableCell key={'vesting'} align="center">
                    {row['text_details']}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
